import { FEATURE_FLAGS } from '../../../../featureFlags';
const Bot = () => import('./Index.vue');
import { frontendURL } from '../../../../helper/URLHelper';
import { AGENT_BOT_PERMISSIONS } from 'dashboard/constants/permissions.js';
import SettingsWrapper from '../SettingsWrapper.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/agent-bots'),
      meta: {
        permissions: ['administrator', AGENT_BOT_PERMISSIONS],
      },
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'agent_bots',
          component: Bot,
          meta: {
            featureFlag: FEATURE_FLAGS.AGENT_BOTS,
            permissions: ['administrator', AGENT_BOT_PERMISSIONS],
          },
        },
      ],
    },
  ],
};
